import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { formatDate, formatToZMW, handlePrint, handleExcel, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import { FaPrint, FaSpinner, FaToggleOff, FaToggleOn, FaFileExcel, FaFilePdf, FaBuilding, FaEye, FaEyeSlash, FaFilter } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Select from "react-select";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const Payments = ({startDate, endDate, triggerFetch}) => {
  const [cashData, setCashData] = useState([]);
  const [cashBooks, setCashBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(false);

  useEffect(()=>{
    console.log(cashBooks)
  }, [cashBooks])

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();

  const bankOptions = allData?.bank.map((bank) => {
    return {
      value: bank.id,
      label: bank.name,
    };
  });

  const [columnVisibility, setColumnVisibility] = useState({
    accountCode: true,
    accountName: true,
    totalBudget: true,
    flexed: true,
    actual: true,
    actualToDate: true,
    performance: true,
    difference: true,
    budgetPerformance: true,
  });



  const componentRef = useRef(null)

  function getMonthDifference(startDate, endDate) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    return years * 12 + months;
}

  var accountCodesAndNames = [
    { id: "151", name: "LOCAL TAXES" },
    { id: "152", name: "FEES AND CHARGES" },
    { id: "153", name: "LICENCES" },
    { id: "154", name: "LEVIES" },
    { id: "155", name: "PERMITS" },
    { id: "156", name: "CHARGES" },
    { id: "157", name: "OTHER INCOMES" },
    { id: "158", name: "NATIONAL SUPPORT (GRANTS)" },
    { id: "159", name: "DONOR SUPPORT" },
    { id: "111", name: "Total" },
    { id: "211", name: "Salaries" },
    { id: "212", name: "Wages" },
    { id: "213", name: "Allowances" },
    { id: "214", name: "Emolument Expenses" },
    { id: "221", name: "Office Costs" },
    { id: "222", name: "Building, Repair and Maintenance Costs" },
    { id: "223", name: "Plant, Machinery, Vehicle Running and Maintenance Costs" },
    { id: "224", name: "Other Administrative Operating Costs" },
    { id: "225", name: "Requisites" },
    { id: "226", name: "Services" },
    { id: "227", name: "Travel Expenses" },
    { id: "228", name: "Training" },
    { id: "229", name: "Legal Costs" },
    { id: "231", name: "Depreciation on Own Assets" },
    { id: "232", name: "Depreciation on Leased Property (Finance Lease)" },
    { id: "241", name: "Interest on Domestic Debt" },
    { id: "242", name: "Interest on External Debt" },
    { id: "243", name: "Financial Charges" },
    { id: "244", name: "Settlement of Outstanding Bills - Financial Charges" },
    { id: "249", name: "Other Financial Charges" },
    { id: "251", name: "Social Assistance Benefits" },
    { id: "261", name: "Grants to Grant-aided Institutions" },
    { id: "262", name: "Grants to Non-Governmental Organisations" },
    { id: "263", name: "Grants to Households" },
    { id: "264", name: "Grants to Institutional Revolving Funds" },
    { id: "265", name: "Other Grants" },
    { id: "267", name: "Other Payments" },
    { id: "271", name: "Subsidies to Non-Financial Enterprises" },
    { id: "272", name: "Subsidies to Financial Institutions" },
    { id: "273", name: "Subsidies to Private Enterprises" },
    { id: "274", name: "Other Subsidies" },
    { id: "281", name: "Legal Expenses" },
    { id: "291", name: "Constitutional Expenditure" },
    { id: "292", name: "Other Constitutional Expenditure" },
    { id: "293", name: "Allowances" },
    { id: "294", name: "Statutory Expenditure" },
    { id: "295", name: "Other Expenses" },
    { id: "311", name: "Fixed Assets" },
    { id: "312", name: "Stocks (Inventories)" },
    { id: "313", name: "Valuables" },
    { id: "314", name: "Non-Produced Assets" },
    { id: "320", name: "Long Term Investments" },
    { id: "321", name: "Debtors" },
    { id: "322", name: "Staff Debtors" },
    { id: "323", name: "Prepayments" },
    { id: "324", name: "VAT refunds" },
    { id: "325", name: "Foreign Debtors" },
    { id: "326", name: "Cash and Cash Equivalents" },
    { id: "411", name: "Creditors" },
    { id: "421", name: "Creditors" },
    { id: "520", name: "Current Year Surplus/(Deficit)" },
    { id: "530", name: "Reserves" },
    { id: "611", name: "Realised Gains/Losses" },
    { id: "621", name: "Unrealised Gains/Losses" },
    { id: "631", name: "Miscellaneous" },
    { id: "510", name: "Owners Fund" },
    { id: "000", name: "Rest" },
  ];
  const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);

  // Fetch data when triggerFetch changes (triggered by button in parent)
  useEffect(() => {
    if (triggerFetch && startDate && endDate) {
      setLoading(true);
      axios
        .get(rootUrl(`/getCashByDate/${auth.user?.cid}~${startDate}~${endDate}`))
        .then((response) => {
          const cash = response.data.data;
          setCashData(cash?.cash);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching data', error);
          toast.error('Error fetching data');
          setLoading(false);
        });
    }
  }, [triggerFetch]);

  if (loading) {
    return (
      <div className='flex flex-col justify-center items-center h-64 bg-gray-50 rounded-xl border border-gray-200'>
        <FaSpinner size={50} className="animate-spin text-blue-950 mb-4" />
        <p className="text-gray-600">Loading report data...</p>
      </div>
    );
  }

  const renderTableRows = () => {
    const rows = [];
    if(!allData.budget){
        return
    }

    let start = new Date(startDate);
    const yr = start.getFullYear()
    // const accounts = [...new Set(allData.budget.map(item => item.coa.substring(0, 3)))];
    const accounts = [...new Set(allData.budget.filter(a=>a.year == yr).map(item => item.coa))].sort((a, b) => a - b);
    
    let months = getMonthDifference(startDate, endDate) + 1;

    let selectedMonth = new Date(endDate).getMonth()

    let totalBudgetg = 0;
    let totalFlexedg = 0;
    let totalActualg = 0;
    let totalActualToDateg = 0;
    let totalDifferenceg = 0;
    

    accountCodesAndNames.forEach((account) => {
      let totalBudget = 0;
      let totalBudgets = 0;
      let totalFlexed = 0;
      let totalActual = 0;
      let totalActualToDate = 0;
      let totalFlexedPerformance = 0;
      let totalDifference = 0;
      let totalBuggedPerformance = 0;


      accounts.forEach((accountCode) => {
        if (account.id === accountCode?.toString().substring(0, 3)) {
          const budgetEntries = allData.budget.filter(item => item.coa == accountCode);
          const coaEntries = allData.coa.filter(item => item.account == accountCode);
          totalBudget = sumOfArray(budgetEntries.filter(a=>a.year == yr).map(item => parseFloat(item.price * item.frequency * item.qty)));
          const flexed = (months / 12) * totalBudget;
          const coa = allData.coa.find(item => item.account == accountCode)?.id;
          const actual = cashBooks.length > 0? sumOfArray(
            cashData
              ?.filter(item => budgetEntries.some(entry => item.coa_id == entry.id) && cashBooks.includes(item.bank)) 
              .map(item => parseFloat(item.amount))
          )  : sumOfArray(
            cashData
              ?.filter(item => budgetEntries.some(entry => item.coa_id == entry.id)) 
              .map(item => parseFloat(item.amount))
          );

          const actualOne = cashBooks.length > 0
          ? sumOfArray(
              cashData
                ?.filter(item =>
                  budgetEntries.some(entry => item.coa_id == entry.id) &&
                  cashBooks.includes(item.bank) &&
                  new Date(item.date).getMonth() === selectedMonth
                )
                .map(item => parseFloat(item.amount))
            )
          : sumOfArray(
              cashData
                ?.filter(item =>
                  budgetEntries.some(entry => item.coa_id == entry.id) &&
                  new Date(item.date).getMonth() === selectedMonth
                )
                .map(item => parseFloat(item.amount))
            );
        

       
          if(totalBudget > 0 && !toggle){
            
            rows.push(
                <tr key={accountCode} className="hover:bg-gray-50 transition-colors border-b border-gray-200">
                   {columnVisibility.accountCode && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-gray-700">{accountCode}</td>
                  )}
                   {columnVisibility.accountName && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-gray-800 font-medium">{coaEntries[0]?.name}</td>
                  )}
                   {columnVisibility.totalBudget && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700">{formatToZMW(totalBudget)}</td>
                  )}
                  {columnVisibility.flexed && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700">{formatToZMW(flexed)}</td>
                  )}
                   {columnVisibility.actual && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700">{formatToZMW(actualOne)}</td>
                  )}
                  {columnVisibility.actualToDate && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700 font-medium">{formatToZMW(actual)}</td>
                  )}
                   {columnVisibility.performance && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700">{((actual / flexed) * 100).toFixed()}%</td>
                  )}
                   {columnVisibility.difference && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700">{formatToZMW(totalBudget - actual)}</td>
                  )}
                  {columnVisibility.budgetPerformance && (
              <td className="border border-gray-200 py-2.5 px-4 text-sm text-right text-gray-700">{((actual / totalBudget) * 100).toFixed()}%</td>
            )}
                </tr>
              );
          }
     
          totalBudgets += totalBudget;
          totalFlexed += flexed;
          totalActual += actualOne;
          totalActualToDate += actual;
          totalFlexedPerformance += (actual / flexed) * 100;
          totalDifference += totalBudget - actual;
          totalBuggedPerformance += (actual / totalBudget) * 100;
        }
      });


      if(totalBudget > 0){
        rows.push(
            <tr key={`${account.id}-total`} className={`${!toggle?'bg-gray-800 text-white':'bg-gray-100'} border-t-2 border-gray-400`} >
            {columnVisibility.accountCode && (
            <td className="border border-gray-300 py-3 px-4 font-semibold text-sm">{account.id}</td>
            )}
            {columnVisibility.accountName && (
            <td className="border border-gray-300 py-3 px-4 font-semibold text-sm">{account.name}</td>
            )}
            {columnVisibility.totalBudget && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{formatToZMW(totalBudgets)}</td>
            )}
            {columnVisibility.flexed && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{formatToZMW(totalFlexed)}</td>
            )}
            {columnVisibility.actual && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{formatToZMW(totalActual)}</td>
            )}
            {columnVisibility.actualToDate && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{formatToZMW(totalActualToDate)}</td>
            )}
            {columnVisibility.performance && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{((totalActualToDate / totalFlexed) * 100).toFixed()}%</td>
            )}
            {columnVisibility.difference && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{formatToZMW(totalBudgets - totalActualToDate)}</td>
            )}
            {columnVisibility.budgetPerformance && (
            <td className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">{((totalActualToDate / totalBudgets) * 100).toFixed()}%</td>
            )}
            </tr>
          );

        }

            totalBudgetg += totalBudgets
            totalFlexedg += totalFlexed;
            totalActualg += totalActual;
            totalActualToDateg += totalActualToDate;
            totalDifference += totalBudgetg - totalActualToDateg;
          

          if(account.id == "111"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-gradient-to-r from-green-600 to-green-700 text-white border-t-4 border-green-800`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-4 py-3 border border-green-500 font-bold text-base'>{'Total Income'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{((totalActualToDateg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalBudgetg - totalActualToDateg)}</td>
             )}
             {columnVisibility.budgetPerformance && (
         <td className="border border-green-500 py-3 px-4 text-right font-bold text-base">{((totalActualToDateg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

          if(account.id == "000"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-gradient-to-r from-red-600 to-red-700 text-white border-t-4 border-red-800`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-4 py-3 border border-red-500 font-bold text-base'>{'Total Expenditure'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{((totalActualToDateg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{formatToZMW(totalBudgetg - totalActualToDateg)}</td>
             )}
             {columnVisibility.budgetPerformance && (
         <td className="border border-red-500 py-3 px-4 text-right font-bold text-base">{((totalActualToDateg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

        
      

    });

    return rows;
  };

  const handleColumnToggle = (column) => {
    setColumnVisibility((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  const handleExportToPDF = () => {
    const input = componentRef.current;
    if (!input) return;
    
    html2canvas(input, { scrollY: -window.scrollY }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      // Calculate the height of the content in the PDF
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;
      let heightLeft = imgHeight;
      
      let position = 0;
      
      // Add the first page
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
      
      // Add more pages if needed
      while (heightLeft > 0) {
        position -= pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
      
      const fileName = `Payments_${startDate}_${endDate}.pdf`;
      pdf.save(fileName);
    });
  };

  const handleExportToExcel = () => {
    const fileName = `Payments_${startDate}_${endDate}`;
    handleExcel(componentRef, fileName);
  };

 



  return (
    <div className="cash-report space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-blue-950 rounded-lg">
          <FaBuilding className="text-white text-xl" />
        </div>
        <div>
          <h1 className='font-bold text-xl md:text-2xl text-gray-900'>Receipts and Payments By COA</h1>
          <p className="text-sm text-gray-500">Chart of Accounts breakdown</p>
        </div>
      </div>

      {/* Filters and Controls */}
      <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 space-y-4">
        {/* Bank Filter */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-center gap-2">
            <FaFilter className="text-gray-600" />
            <label className="text-sm font-medium text-gray-700">Filter by Bank:</label>
          </div>
          <div className="flex-1 max-w-md">
            <Select
              options={bankOptions}
              placeholder="Select banks..."
              isClearable
              isMulti
              className="text-sm"
              value={bankOptions.filter(option => cashBooks.includes(option.value))}
              onChange={(selectedOptions) =>
                setCashBooks(selectedOptions ? selectedOptions.map(opt => opt.value) : [])
              }
            />
          </div>
        </div>

        {/* Toggle and Column Visibility */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4 border-t border-gray-300">
         
        <div className="flex items-center gap-2 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap text-sm text-gray-600">
              {toggle ? <FaEyeSlash /> : <FaEye />}
           
           
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-blue-950 text-white rounded-lg hover:bg-blue-900 transition-colors font-medium text-sm" 
            onClick={()=>setToggle(!toggle)}
          >
            {toggle ? <FaToggleOn size={20} /> : <FaToggleOff size={20} />}
            <span>{toggle ? 'Show Details' : 'Hide Details'}</span>
          </button>
          </div>
          </div>
         
         

          <div className="flex items-center gap-2 flex-wrap">
            <div className="flex items-center gap-2 text-sm text-gray-600">
             
              <span className="font-medium">Columns:</span>
            </div>
            <div className="flex flex-wrap gap-2">
              {Object.keys(columnVisibility).map((column) => (
                <label
                  key={column}
                  className="flex items-center space-x-2 bg-white px-3 py-1.5 rounded-lg border border-gray-300 shadow-sm hover:bg-gray-50 cursor-pointer transition-colors"
                >
                  <input
                    type="checkbox"
                    checked={columnVisibility[column]}
                    onChange={() => handleColumnToggle(column)}
                    className="h-4 w-4 text-blue-600 focus:ring-2 focus:ring-blue-500 rounded"
                  />
                  <span className="text-xs font-medium text-gray-700 capitalize">{column.replace(/([A-Z])/g, ' $1').trim()}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Export Actions */}
      <div className="flex items-center justify-end gap-2">
        <button
          onClick={handleExportToExcel}
          className="px-4 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
          title="Export to Excel"
        >
          <FaFileExcel />
          <span>Excel</span>
        </button>
        <button
          onClick={handleExportToPDF}
          className="px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
          title="Export to PDF"
        >
          <FaFilePdf />
          <span>PDF</span>
        </button>
        <button
          onClick={() => handlePrint(componentRef)}
          className="px-4 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium text-sm flex items-center gap-2 shadow-sm"
          title="Print"
        >
          <FaPrint />
          <span>Print</span>
        </button>
      </div>
      {/* Report Content */}
      <div ref={componentRef} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        {/* Report Header */}
        <div className='text-center py-6 px-4'>
          <h2 className='font-bold text-xl md:text-2xl mb-2'>{allData.council[0]?.name.toUpperCase()}</h2>
          <h2 className="font-bold text-lg md:text-xl mb-3">{'Receipts and Payments By COA'.toUpperCase()}</h2>
          <h3 className='text-base md:text-lg font-medium opacity-90'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className='bg-gradient-to-r from-blue-950 to-blue-900 text-white'>
                {columnVisibility.accountCode && (
                  <th className="border border-gray-300 py-3 px-4 text-left font-semibold text-sm">Account Code</th>
                )}
                {columnVisibility.accountName && (
                  <th className="border border-gray-300 py-3 px-4 text-left font-semibold text-sm">Account Name</th>
                )}
                {columnVisibility.totalBudget && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Total Budget</th>
                )}
                {columnVisibility.flexed && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Flexed</th>
                )}
                {columnVisibility.actual && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Actual</th>
                )}
                {columnVisibility.actualToDate && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Actual to Date</th>
                )}
                {columnVisibility.performance && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Performance</th>
                )}
                {columnVisibility.difference && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Difference</th>
                )}
                {columnVisibility.budgetPerformance && (
                  <th className="border border-gray-300 py-3 px-4 text-right font-semibold text-sm">Budget Performance</th>
                )}
              </tr>
            </thead>
            <tbody className="bg-white">
              {renderTableRows()}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Payments;
